/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_SubInputs */

const en_mk_price_sub = /** @type {(inputs: Mk_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three plans, one Rupiah-per-seat-per-month unit — no hidden AI fees.`)
};

const id_mk_price_sub = /** @type {(inputs: Mk_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga paket, satu satuan Rupiah per orang per bulan — tanpa biaya AI tersembunyi.`)
};

/**
* | output |
* | --- |
* | "Three plans, one Rupiah-per-seat-per-month unit — no hidden AI fees." |
*
* @param {Mk_Price_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_sub = /** @type {((inputs?: Mk_Price_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_sub(inputs)
	return en_mk_price_sub(inputs)
});